import {gatewayUrl} from "config";

export const eGoldHostUrl = `${gatewayUrl}/egold`;

export enum vendor {
    SAFEGOLD = "safegold",
}
